import { useMemo } from 'react'
import { addGtmPrefix } from '../core'
import { useAbTestPattern } from './useAbTestPattern'

interface UseAbTestGtmProps {
    abValue?: number
    currentPath?: string
}

interface GtmLabels {
    dataClickLabel: (originalLabel: string) => string
    dataViewLabel: (originalLabel: string) => string
}

// パターン判定は useAbTestPattern に一本化している。以前は同じcookieの読み書きを
// こちらにも複製していた。DEV-3390で参加条件（クエリ条件）を入れる際、複製したままだと
// こちらが対象外の流入にもcookieを書いて参加判定を無効化してしまうため、その前提として
// 畳んだもの（実際に不具合が出たわけではない）。条件自体はDEV-3574で基盤から外したが、
// 複製に戻す理由は無いのでこのまま。
// なお同じコンポーネントがこのフックと useAbTestPattern を両方呼ぶ構成では、
// useAbTestPattern のインスタンスは依然2つになる（cookieを介して値は揃う）。
export const useAbTestGtm = ({
    abValue,
    currentPath = typeof window !== 'undefined'
        ? window.location.pathname
        : '/',
}: UseAbTestGtmProps = {}): GtmLabels => {
    const { pattern, isResolved } = useAbTestPattern({
        abValue,
        currentPath,
    })

    return useMemo(
        () => ({
            // 判定が確定するまでは素のラベルを返す（従来どおり）
            dataClickLabel: (originalLabel: string): string =>
                isResolved ? addGtmPrefix(originalLabel, currentPath, pattern) : originalLabel,

            dataViewLabel: (originalLabel: string): string =>
                isResolved ? addGtmPrefix(originalLabel, currentPath, pattern) : originalLabel,
        }),
        [isResolved, pattern, currentPath]
    )
}


